import { render, staticRenderFns } from "./CheckProducts.vue?vue&type=template&id=5f6c6de6&scoped=true&"
import script from "./CheckProducts.vue?vue&type=script&lang=js&"
export * from "./CheckProducts.vue?vue&type=script&lang=js&"
import style0 from "./CheckProducts.vue?vue&type=style&index=0&id=5f6c6de6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6c6de6",
  null
  
)

export default component.exports